//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import { CosMixin } from '@/mixins/cos';
import { cloneDeep } from 'lodash';
import { addCdnResource } from '@/graphql/api/cdn_resource';

const defaultForm = {
  name: '',
  cdn_url: '',
  remark: '',
};

export default {
  name: 'EditAgentAppDetail',
  components: { Drawer },
  mixins: [CosMixin],
  props: {
    row: { type: Object, default: () => {} },
    type: { type: String, default: 'create' },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: cloneDeep(defaultForm),
      fileList: [],
      rules: {
        name: [{ required: true, message: '请输入资源名称', trigger: 'blur' }],
        cdn_url: [{ required: true, message: '请上传资源文件', trigger: 'change' }],
      },
      loading: false,
    };
  },
  watch: {
    visible() {
      this.$refs?.form?.clearValidate();
      if (this.visible) {
        this.form = cloneDeep(defaultForm);
        this.fileList = [];
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },
    async handleRequest(file) {
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      // 截取文件类型
      const lastPointIndex = rs.lastIndexOf('.');
      const suffix = rs.substring(lastPointIndex);
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
        suffix,
      };
      try {
        this.loading = true;
        const res = await this.putCosObject(cosParams);
        this.fileList.push({
          name: res.data,
          url: res.data,
          role: null,
          package: null,
          path: null,
        });
        this.$set(this.form, 'cdn_url', res.data);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$message('上传失败，请稍后再试');
      }
    },
    handleUploadRemove() {
      this.fileList = [];
      this.$set(this.form, 'cdn_url', '');
    },
    handleOnExceed() {
      this.$message.error('只能上传一个文件');
    },
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          const formData = cloneDeep(this.form);
          console.log('submit data: ', formData);
          addCdnResource(formData)
            .then((res) => {
              console.log('%c Line:154 🥕 res', 'color:#42b983', res);
              this.$emit('refresh');
              this.$message.success('上传资源成功');
              this.close();
            })
            .catch(() => {
              this.$message.error('上传资源失败');
            });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
